/**
 * Parse-time autoplay suppression for prefers-reduced-motion.
 * Loaded without defer from theme.liquid so the observer is registered before body media parses.
 * Disconnects on DOMContentLoaded so user-clicked deferred Vimeo embeds can still autoplay.
 */
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const stripAutoplay = (node) => {
    if (!node || node.nodeType !== 1) return;

    if (node.nodeName === 'VIDEO' && (node.hasAttribute('autoplay') || node.autoplay)) {
      node.removeAttribute('autoplay');
      node.autoplay = false;
      if (typeof node.pause === 'function') node.pause();

      const container =
        node.closest('video-element, .video-container, .deferred-media, .video-wrapper, .product-media-container') ||
        node.parentElement;
      const playControl = container?.querySelector('.video__control.play');
      const pauseControl = container?.querySelector('.video__control.pause');
      if (playControl) playControl.hidden = false;
      if (pauseControl) pauseControl.hidden = true;
    }

    if (
      node.nodeName === 'IFRAME' &&
      node.src &&
      node.src.includes('player.vimeo.com') &&
      node.src.includes('autoplay=1')
    ) {
      node.src = node.src.replace(/autoplay=1/g, 'autoplay=0');
    }

    if (!node.querySelectorAll) return;

    for (const video of node.querySelectorAll('video[autoplay]')) {
      stripAutoplay(video);
    }
    for (const iframe of node.querySelectorAll('iframe.js-vimeo, iframe[src*="player.vimeo.com"]')) {
      stripAutoplay(iframe);
    }
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const addedNode of mutation.addedNodes) {
        stripAutoplay(addedNode);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', () => observer.disconnect(), { once: true });
}
